module.exports = __webpack_public_path__ + "static/media/neville_ying.fef7b0c4.pdf";